function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.123 1.94a.375.375 0 010-.533L.918.612a.36.36 0 01.525 0l6.892 6.893a.563.563 0 01.165.397v.195c0 .15-.06.293-.165.398l-6.892 6.893a.36.36 0 01-.525 0l-.795-.796a.375.375 0 010-.532L6.183 8 .123 1.94z"
});

var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 1,
    fill: "#fff",
    viewBox: "0 0 9 16"
  }, props), _ref);
};

export default SvgChevronRight;